import { ERROR_FORM_ANSWERS_NEEDED, ERROR_FORM_ANSWERS_WRONG,
  missionPEOField } from '../../../../../utils/constants'

const hasAnswer = (page_element, answers_selected) =>
  !!(!page_element.required || answers_selected.reduce((x, y) => x || y, false))

const isCorrectAnswer = (page_element, answers_selected) =>
  !page_element.has_answer || page_element.page_element_options.map((peo, index) =>(
    (peo.is_correct_answer && answers_selected[index]) ||
      (!peo.is_correct_answer && !answers_selected[index]) //MAGIA
  )).reduce((x, y) => x && y, true)

export default (page_element, answer) => {
  const answers_selected = page_element.page_element_options.map(peo =>
    answer[missionPEOField(page_element, peo)],
  )
  const has_answer = hasAnswer(page_element, answers_selected)
  const is_correct_answer = isCorrectAnswer(page_element, answers_selected)
  const errors = new Set()
  if (!has_answer) {
    errors.add(ERROR_FORM_ANSWERS_NEEDED)
  } else if (!is_correct_answer) {
    errors.add(ERROR_FORM_ANSWERS_WRONG)
  }
  return {
    valid: has_answer,
    is_correct_answer,
    errors,
  }
}

// MAGIA
// peo.is_correct_answer:    true  true  false false
// answers_selected[index]:  true  false true  false
// -------------------------------------------------
// is_correct?:              true  false false true

// X:     true  true  false false
// Y:     true  false true  false
// -------------------------------------------------
// X & Y: true  false false true



// WEBPACK FOOTER //
// ./src/reducers/Missions/Progress/validators/Form/checkbox.jsx